import { render, staticRenderFns } from "./view-travel-authorization.vue?vue&type=template&id=d40347a4&"
import script from "./view-travel-authorization.vue?vue&type=script&lang=js&"
export * from "./view-travel-authorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports